import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.parse-int.js';
import 'core-js/modules/es.string.trim.js';
import { __awaiter } from '../../_virtual/_tslib.js';
import { Envs } from '../envs.js';

class MultiTokenizer {
  loadIuguScript() {
    return new Promise((resolve, reject) => {
      if (typeof (window === null || window === void 0 ? void 0 : window.Iugu) !== 'undefined') return resolve(true);
      const script = document.createElement('script');
      script.src = 'https://js.iugu.com/v2';
      script.type = 'text/javascript';
      script.onload = () => resolve(true);
      script.onerror = () => reject(new Error('Failed to load Iugu script'));
      document.head.appendChild(script);
    });
  }
  tokenize({
    number,
    expiration,
    holder,
    cvv,
    sessionId,
    document
  }) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
      yield this.loadIuguScript();
      const [month, year] = expiration.split('/');
      const firstName = holder.split(' ').slice(0, 1).join(' ');
      const lastName = holder.split(' ').slice(-1).join(' ');
      (_a = window === null || window === void 0 ? void 0 : window.Iugu) === null || _a === void 0 ? void 0 : _a.setAccountID(Envs.IUGU_ACCOUNT_ID);
      (_b = window === null || window === void 0 ? void 0 : window.Iugu) === null || _b === void 0 ? void 0 : _b.setTestMode(Envs.IUGU_TEST_MODE === 'true');
      (_c = window === null || window === void 0 ? void 0 : window.Iugu) === null || _c === void 0 ? void 0 : _c.setup();
      this.tokenizeOnYuno(month, year, number, cvv, holder, document, sessionId);
      return new Promise((resolve, reject) => {
        var _a, _b;
        return (_a = window === null || window === void 0 ? void 0 : window.Iugu) === null || _a === void 0 ? void 0 : _a.createPaymentToken((_b = window === null || window === void 0 ? void 0 : window.Iugu) === null || _b === void 0 ? void 0 : _b.CreditCard(number, month, year, firstName, lastName, cvv), response => {
          if (response.errors) {
            return reject(JSON.stringify(response.errors));
          }
          resolve({
            tokenId: response.id
          });
        });
      });
    });
  }
  tokenizeOnYuno(month, year, number, cvv, holder, document, sessionId) {
    var _a;
    const browserInfo = {
      browser_time_difference: new Date().getTimezoneOffset().toString(),
      color_depth: window.screen.colorDepth.toString(),
      java_enabled: navigator.javaEnabled(),
      screen_width: window.screen.width.toString(),
      screen_height: window.screen.height.toString(),
      user_agent: navigator.userAgent,
      language: navigator.language,
      javascript_enabled: true,
      accept_browser: navigator.accepts ? navigator.accepts[0].type : '*/*',
      accept_content: navigator.accepts ? navigator.accepts[1].type : '*/*',
      accept_header: navigator.accepts ? navigator.accepts[2].type : '*/*'
    };
    const requestBody = {
      card: {
        expiration_month: parseInt(month, 10),
        expiration_year: parseInt(year, 10),
        number: number,
        security_code: cvv,
        holder_name: holder,
        type: null
      },
      customer: {
        document: {
          document_number: document,
          document_type: document && ((_a = document.trim()) === null || _a === void 0 ? void 0 : _a.length) > 14 ? 'CNPJ' : 'CPF'
        },
        browser_info: browserInfo
      }
    };
    const body = JSON.stringify(requestBody);
    fetch(`${Envs.YUNO_API_URL}/v1/sdk/customers/sessions/${sessionId}/payment-methods/enroll?public-api-key=${Envs.YUNO_PUBLIC_API_KEY}`, {
      headers: {
        accept: 'application/json, text/plain, */*',
        'accept-language': 'en-US',
        'cache-control': 'no-cache',
        'content-type': 'application/json',
        pragma: 'no-cache'
      },
      referrer: 'https://sdk-web-card.prod.y.uno/',
      referrerPolicy: 'strict-origin-when-cross-origin',
      body,
      method: 'POST',
      mode: 'no-cors',
      credentials: 'omit'
    });
  }
}

export { MultiTokenizer };
